var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
export class SellerEntity {
  constructor(_data) {
    /**
     */
    __publicField(this, "Id");
    /**
     */
    __publicField(this, "IsAutomated");
    /**
     */
    __publicField(this, "IsEnabled");
    /**
     */
    __publicField(this, "MwsAuthToken");
    /**
     */
    __publicField(this, "Name");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof SellerEntity
     */
    __publicField(this, "$type", "V1.Companies.FileUploadConfiguration.Amazon.SellerEntity");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.Id = _data["Id"];
      this.IsAutomated = _data["IsAutomated"];
      this.IsEnabled = _data["IsEnabled"];
      this.MwsAuthToken = _data["MwsAuthToken"];
      this.Name = _data["Name"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["Id"] = this.Id;
    _data["IsAutomated"] = this.IsAutomated;
    _data["IsEnabled"] = this.IsEnabled;
    _data["MwsAuthToken"] = this.MwsAuthToken;
    _data["Name"] = this.Name;
    return _data;
  }
}
